
import React, { ChangeEvent, useEffect, useState } from 'react'
import { scheduleOptions, ShareAllotmentT } from '../../../../utils/constants';
import { Box, CustomDatePicker, CustomSelect } from 'ui-components';
import InputField from '../../../../components/shared/input-field';
import { Card } from '@blueprintjs/core';
import { generateCron, getDateFromCron, getDayFromCron } from '../../../../utils';

const ShareAllotMent = ({
	idx,
	share,
	handleShareScheduleChange,
	handleOnChange
}: {
	idx: number,
	share: ShareAllotmentT,
	handleShareScheduleChange: (index: number, value: string) => void,
	handleOnChange: (event: (ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLTextAreaElement>)) => void
}) => {
	const [shareScheduleType,setShareScheduleType] = useState(getDayFromCron(share?.schedule?.cron || ""));
	const [selectedDate, setSelectedDate] = useState<Date | null>(getDateFromCron(share.schedule?.cron || ""));
	useEffect(()=>{
		const detectedType = getDayFromCron(share?.schedule?.cron || "");
		setShareScheduleType(detectedType);
		setShareScheduleType(detectedType);
		setSelectedDate(getDateFromCron(share?.schedule?.cron || ""));
	},[share?.schedule?.cron])
	return (
		<Card className='mb-sm'>
			<Box flexDir='row' justify='between'>
				<CustomSelect
					title="Schedule"
					flexDir="row"
					isActiveItem={true}
					label={shareScheduleType}
					items={scheduleOptions}
					values={[shareScheduleType]}
					onSelect={(item) => {
						setShareScheduleType(item.value)
					}}
				/>
				{shareScheduleType === "Custom" &&
					<InputField
						inputContainerClass='mt-none'
						name={`configDetail.share_allotment.${idx}.schedule.cron`}
						type="text"
						value={share?.schedule?.cron}
						placeholder="enter the custom cron"
						onChange={handleOnChange}
						ptb='5px'
						bradius='5px'
					/>
				}
				{(shareScheduleType != 'Custom' && shareScheduleType != 'Daily') &&
					<CustomDatePicker
						mode="in_date"
						value={selectedDate || ""}
						onValueChange={(dates) => {
							const newDate = dates.length > 0 ? dates[0] : new Date();
							setSelectedDate(newDate);
							const cron = generateCron(shareScheduleType, newDate);
							handleShareScheduleChange(idx,cron);
						}}
						startDate={new Date()}
					/>
				}
			</Box>
			{(["url", "response_key", "base_regex"] as const).map((field) => (
				<InputField
					key={field}
					label={field
						.split("_")
						.map(word => word.charAt(0).toUpperCase() + word.slice(1))
						.join(" ")}
					name={`configDetail.share_allotment.${idx}.${field}`}
					type="text"
					value={share[field]}
					onChange={handleOnChange}
				/>
			))}
			{Object.entries({
				...share.key_and_regex
			}).map(([key, val]) => (
				<InputField
					key={key}
					label={key
						.split("_")
						.map(word => word.charAt(0).toUpperCase() + word.slice(1))
						.join(" ")}
					name={`configDetail.share_allotment.${idx}.key_and_regex.${key}`}
					type="text"
					value={val !== undefined && val !== null ? val : ""}
					onChange={handleOnChange}
				/>
			))}
		</Card>

	)
}

export default ShareAllotMent
